import React from 'react';

const Sponsor2 = () => {
    return (
        <>
            <div className='px-4 py-6 mx-auto sm:max-w-xl md:max-w-full  md:px-24 lg:px-8'>
                <div>
                    <h6 className='text-md font-semibold text-gray-800 dark:text-white lg:text-md text-left ml-8'>PATROCINADORES:</h6>
                </div>
                <div className='bg-white dark:bg-gray-900'>
                    <div className='container px-6 py-16 mx-auto text-left -mt-12'>
                        <div className='max-w-screen-xl mx-auto'>
                            <div className='grid grid-cols-2 gap-8 md:grid-cols-6 lg:grid-cols-5 mr-16'>
                                <div className='flex items-center justify-center col-span-1 md:col-span-2 lg:col-span-1 object-cover scale-90'>
                                    <img src='/assets/patrocinadores/1.png' alt='logo universitat de valencia'/>
                                </div>
                                <div className='flex items-center justify-center col-span-1 md:col-span-2 lg:col-span-1 object-cover scale-90'>
                                    <img src='/assets/patrocinadores/2.png' alt='logo ajuntament de gandia'/>
                                </div>

                                <div className='flex items-center justify-center col-span-1 md:col-span-2 lg:col-span-1 object-cover scale-90'>
                                    <img src='/assets/patrocinadores/3.png' alt='logo cepal'/>
                                </div>

                                <div className='flex items-center justify-center col-span-1 md:col-span-3 lg:col-span-1 object-cover scale-90'>
                                    <img src='/assets/patrocinadores/4.png' alt='logo ogp local'/>
                                </div>
                                <div className='flex items-center justify-center col-span-1 md:col-span-3 lg:col-span-1 object-cover scale-90'>
                                    <img src='/assets/patrocinadores/5.png' alt='logo innovarancagua'/>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Section 2 */}
                    <div className='container px-6 py-16 mx-auto text-left -mt-12'>
                        <div className=' mx-auto'>
                            <div className='grid grid-cols-2 gap-8 md:grid-cols-6 lg:grid-cols-5'>
                                <div className='flex items-center justify-center col-span-1 md:col-span-2 lg:col-span-1 scale-90'>
                                    <img src='/assets/patrocinadores/6.png' alt='logo ogp'/>
                                </div>

                                <div className='flex items-center justify-center col-span-1 md:col-span-2 lg:col-span-1 scale-90'>
                                    <img src='/assets/patrocinadores/7.png' alt='logo cormun'/>
                                </div>

                                <div className='flex items-center justify-center col-span-1 md:col-span-2 lg:col-span-1 scale-90'>
                                    <img src='/assets/patrocinadores/8.png' alt='logo universidad de chile'/>
                                </div>

                                <div className='flex items-center justify-center col-span-1 md:col-span-3 lg:col-span-1 scale-90'>
                                    <img src='/assets/patrocinadores/9.png' alt='logo secretaria'/>
                                </div>
                                <div className='flex items-center justify-center col-span-1 md:col-span-3 lg:col-span-1 scale-90'>
                                    <img src='/assets/patrocinadores/10.png' alt='logo integridad publica'/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
        </>
    );
};

export default Sponsor2;